// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SocialTwitterComponent} from './SocialTwitter.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSocialTwitter = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SocialTwitterComponent/>
  </Icon>
));
